// ---------------------------------------------------------------------------
// PWA Caisse Tablette — Single cart item row
// ---------------------------------------------------------------------------

import type { CartItem as CartItemType } from '@/lib/types';
import { formatPrice } from '@/lib/price-formatter';

interface CartItemProps {
  item: CartItemType;
  onUpdateQty: (qty: number) => void;
  onRemove: () => void;
}

export default function CartItem({ item, onUpdateQty, onRemove }: CartItemProps) {
  return (
    <div className="flex items-center gap-2 py-2 border-b border-white/5">
      {/* Name + unit price */}
      <div className="flex-1 min-w-0">
        <p className="text-sm text-white truncate">{item.name}</p>
        <p className="text-xs text-gray-400">{formatPrice(item.price)}</p>
      </div>

      {/* Quantity controls */}
      <div className="flex items-center gap-1.5">
        <button
          type="button"
          onClick={() => onUpdateQty(item.quantity - 1)}
          className="w-7 h-7 flex items-center justify-center rounded bg-surface-card text-white text-sm font-bold hover:bg-surface-hover"
        >
          -
        </button>
        <span className="text-sm font-medium text-white w-6 text-center">
          {item.quantity}
        </span>
        <button
          type="button"
          onClick={() => onUpdateQty(item.quantity + 1)}
          className="w-7 h-7 flex items-center justify-center rounded bg-surface-card text-white text-sm font-bold hover:bg-surface-hover"
        >
          +
        </button>
      </div>

      {/* Line total */}
      <span className="text-sm font-semibold text-white w-16 text-right">
        {formatPrice(item.total)}
      </span>

      {/* Remove */}
      <button
        type="button"
        onClick={onRemove}
        className="p-1 text-gray-400 hover:text-danger"
        aria-label="Supprimer"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>
  );
}
